var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":'https://api.cmspricer.com/cmsp1',"id":"iframe","name":"my-frame","width":"100%","height":"100%"},on:{"load":_vm.onLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }